import React from 'react';
import { I18n } from '@aws-amplify/core';

import { CustomFormItem, CustomSelect } from '../../styles';
import { FieldContainer } from '../styles';
import { FieldsProps } from '../types';

interface RenewalMonthProps extends FieldsProps {
	disabled?: boolean;
}

export function RenewalMonth({ name, required = false, disabled = false }: Readonly<RenewalMonthProps>) {
	const daysList = Array.from(Array(12).keys());

	const options = daysList.map((number) => {
		return {
			value: number + 1,
			label: number + 1
		};
	});

	return (
		<FieldContainer disabled={disabled}>
			<CustomFormItem
				name={name}
				labelCol={{ span: 24 }}
				label={I18n.get('Renewal Month')}
				rules={[{ required, message: I18n.get('Enter a renewal Month') }]}
			>
				<CustomSelect disabled={disabled} placeholder={I18n.get('Renewal Month')} options={options} />
			</CustomFormItem>
		</FieldContainer>
	);
}
